var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1068,
    height: 93,
    viewBox: "0 0 1068 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3498_3590",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1068,
    height: 93
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1068,
    height: 93,
    rx: 5,
    fill: "url(#paint0_linear_3498_3590)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3498_3590)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1091,
    height: 93,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1272.98 228.291L1272.99 228.256L1273 228.22C1284.07 183.045 1285.87 138.712 1273.5 105.642C1267.31 89.0977 1257.57 75.3609 1243.66 65.7632C1229.76 56.1655 1211.72 50.7324 1188.97 50.7324C1143.59 50.7324 1096.93 59.0784 1054.48 82.5089C1012.02 105.943 973.801 144.448 945.256 204.711L945.248 204.729L945.24 204.748C918.446 275.932 911.461 331.763 922.598 369.837C928.171 388.889 938.285 403.503 952.725 413.348C967.16 423.19 985.877 428.238 1008.61 428.238C1054.08 428.238 1108.11 407.548 1156.79 372.236C1205.48 336.919 1248.86 286.939 1272.98 228.291Z",
    stroke: "#1A2CCE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1252.34 190.07L1252.35 190.035L1252.36 189.999C1263.43 144.824 1265.23 100.492 1252.86 67.4217C1246.67 50.8769 1236.93 37.1402 1223.02 27.5425C1209.11 17.9448 1191.08 12.5117 1168.33 12.5117C1122.95 12.5117 1076.29 20.8577 1033.84 44.2882C991.383 67.722 953.161 106.227 924.616 166.49L924.607 166.508L924.6 166.528C897.805 237.711 890.821 293.542 901.958 331.616C907.531 350.669 917.644 365.283 932.085 375.128C946.52 384.969 965.237 390.017 987.972 390.017C1033.44 390.017 1087.47 369.328 1136.15 334.015C1184.84 298.698 1228.22 248.719 1252.34 190.07Z",
    stroke: "#1A2CCE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1320.16 240.488L1320.17 240.453L1320.18 240.417C1331.25 195.242 1333.05 150.91 1320.68 117.84C1314.49 101.295 1304.75 87.5581 1290.84 77.9605C1276.93 68.3628 1258.89 62.9297 1236.15 62.9297C1190.76 62.9297 1144.11 71.2757 1101.66 94.7062C1059.2 118.14 1020.98 156.645 992.435 216.908L992.426 216.926L992.419 216.946C965.624 288.129 958.639 343.96 969.776 382.034C975.349 401.087 985.463 415.701 999.903 425.546C1014.34 435.387 1033.06 440.435 1055.79 440.435C1101.25 440.435 1155.29 419.746 1203.97 384.433C1252.66 349.116 1296.04 299.137 1320.16 240.488Z",
    stroke: "#1A2CCE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1199.26 174.619L1199.28 174.584L1199.29 174.548C1210.35 129.373 1212.15 85.0405 1199.78 51.9705C1193.6 35.4258 1183.86 21.689 1169.95 12.0913C1156.04 2.49367 1138 -2.93945 1115.26 -2.93945C1069.87 -2.93945 1023.22 5.40651 980.765 28.8371C938.308 52.2708 900.085 90.7759 871.54 151.039L871.531 151.057L871.524 151.077C844.729 222.26 837.745 278.091 848.882 316.165C854.455 335.218 864.569 349.831 879.009 359.676C893.444 369.518 912.161 374.566 934.896 374.566C980.36 374.566 1034.4 353.876 1083.08 318.564C1131.76 283.247 1175.14 233.268 1199.26 174.619Z",
    stroke: "#1A2CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.73 155.783L1153.73 155.772L1153.73 155.761C1164.79 110.617 1166.58 66.3649 1154.24 33.39C1148.08 16.8997 1138.38 3.22625 1124.54 -6.32373C1110.7 -15.8737 1092.73 -21.2926 1070.04 -21.2926C1024.7 -21.2926 978.108 -12.9542 935.722 10.4404C893.334 33.8359 855.16 72.2835 826.644 132.485L826.644 132.485L826.639 132.497C799.852 203.66 792.901 259.401 804.005 297.364C809.559 316.35 819.629 330.891 833.994 340.684C848.356 350.476 866.999 355.513 889.684 355.513C935.052 355.513 989.018 334.862 1037.66 299.578C1086.3 264.292 1129.63 214.362 1153.73 155.783Z",
    stroke: "#1A2CCE",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1167.15 140.409C1138.28 205.669 1086.37 261.317 1028.07 300.654C969.762 340.002 905.114 362.996 850.832 362.996C823.693 362.996 801.453 357.391 784.351 346.544C767.256 335.703 755.258 319.602 748.634 298.535C735.376 256.372 743.646 194.316 775.777 114.903C844.099 -19.2524 958.645 -56.4219 1067.33 -56.4219C1094.46 -56.4219 1115.89 -50.3948 1132.37 -39.8161C1148.85 -29.2386 1160.41 -14.0888 1167.77 4.21616C1182.5 40.8378 1180.4 90.072 1167.15 140.409Z",
    stroke: "#1A2CCE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3498_3590",
    x1: 534,
    y1: 0,
    x2: 534,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000A62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000A62"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrip);
export default __webpack_public_path__ + "static/media/strip.6fcc24ef7bfb75851e1702e18f1eab98.svg";
export { ForwardRef as ReactComponent };